import { useEffect, useState } from "react";

/**
 * The value once it has stopped changing for `ms`.
 *
 * Typing is the case this exists for: every keystroke in a library search box
 * would otherwise re-run the catalog query and re-render the whole grid, so a
 * three-letter word cost three full passes over 300 tiles. Waiting for the
 * pause means one.
 */
export function useSettled<T>(value: T, ms: number): T {
  const [settled, setSettled] = useState(value);
  useEffect(() => {
    if (settled === value) return;
    const timer = setTimeout(() => setSettled(value), ms);
    return () => clearTimeout(timer);
  }, [value, ms, settled]);
  return settled;
}
